<script>
import { Bar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;
import "chartjs-plugin-datalabels";
import "chartjs-plugin-deferred";

export default {
  name: "bar-chart",
  mixins: [reactiveProp],
  extends: Bar,
  props: {
    chartData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                drawOnChartArea: false
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                drawOnChartArea: false
              }
            }
          ]
        },
        plugins: {
          datalabels: {
            // eslint-disable-next-line no-unused-vars
            formatter: (value, context) => {
              return "";
            }
          },
          deferred: {
            xOffset: 150,
            yOffset: "50%",
            delay: 500
          }
        },
        legend: {
          display: true
        }
      },
      chartStyles: {
        height: `300px`
      }
    };
  },
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options);
  }
};
</script>
